import React, {Component} from 'react';
import {reverseParseTextView} from './createRender';
import Footer from '../exercise/Footer';

const $ = require('$'),
	  MathQuill = require('MathQuill'),
 	  MQ = MathQuill.getInterface(2)

export default class Question extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }
    
    componentDidMount() {
    		this.MQLoad()
    	   setTimeout(()=>{},100)
       
    }
    
    componentDidUpdate(preProps) {
        if (preProps.data.question_id !== this.props.data.question_id) {
            let data = reverseParseTextView(this.props.data);
            this.props.getData && this.props.getData(data);
        }

        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', (d) => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
        
    }

    
    /**handler**/
    createHtml = str => ({__html: str ? str : `&nbsp;`})
	toggleAnswer = (val, e) => {
        e.stopPropagation();
        this.setState({visible: val});
    }
	MQLoad=()=>{
		 $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                MQ.StaticMath(item);
            })
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
        if(this.props.data.subject=='0'){
            this.setState({visible:true})  //数学题默认答案显示
        }
        let data = reverseParseTextView(this.props.data);
        //图片订正解析图片
        this.props.getData && this.props.getData(data);
      
    }
    
    mapTag = str => {
        let stem  = str;
        let regStem = /\(!([āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑńňɡａ-ｚＡ－ＺA-Za-z\\s∥-]+)!\)/ig;
        let regAllText = /([\u4e00-\u9fa5]\(![āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑńňɡａ-ｚＡ－ＺA-Za-z\\s∥-]+!\))/ig;
        stem = stem.replace(regAllText, `<ruby>$1</ruby>`);
        stem = stem.replace(regStem, `<rp>(</rp><rt>$1</rt><rp>)</rp>`);
        return stem;
    }

    /**render**/
    render() {
        let {visible} = this.state,
        		originData = this.props.data,
        		{num, index} = this.props,
        	 	data = reverseParseTextView(originData);
        	 
        if(this.props.errorAnswer){originData.answer = this.props.errorAnswer}//题目检错页显示的是错的的答题答案
        let stem = this.mapTag(data.stem);
       
        return (
            <div className="box-exercise" ref={'viewer'}>
                <div className="exercise-content">
                    {num!='undefined'&&<div className="exercise-num"><p className="math_text" style={{margin: 0, lineHeight: '27px'}}>{index || index === 0 ? `${index+1} - ${num+1}`  : `${num+1}、`}</p></div>}
                    <div className="exercise-con" style={{overflow:'auto'}} dangerouslySetInnerHTML={this.createHtml(stem)}/>
                    {
                        data.item_list && !!data.item_list.length &&
                        <div className="exercise-options">
                            {
                                data.item_list.map((val, key) =>
                                    <div key={key} className="exercise-option">
                                        <div className="exercise-option-code">{val.code}、</div>
                                        <div className="exercise-option-item" dangerouslySetInnerHTML={this.createHtml(this.mapTag(val.item))}/>
                                    </div>
                                )
                            }
                        </div>
                    }
                </div>
                <div className="exercise-footer">
                    {
                        visible &&
                        <div className="footer-hide relative">
                            <div>
                                <div className="inline-block"><span style={{fontSize: 14}}>{this.props.errorAnswer?'错误答案：':'正确答案：'}</span></div>
                                <div className="inline-block" style={{width: '80%'}}>
                                    <span style={{fontSize: 14}}  dangerouslySetInnerHTML={this.createHtml(data.answer.join('、 '))}/>
                                </div>
                            </div>
                            {
                                data.explain && <div>
                                    <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                    <div className="inline-block">
                                        <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(data.explain)}/>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible,e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null

                            }


                        </Footer>
                    </div>
                </div>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/cleanDragSelect/viewForView.js